var map = {
	"./hellohr/circle-4.png": "xkyy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/NJJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/circle\-4\.png$
// module id = /NJJ
// module chunks = 0